import { useEffect, useMemo, useState } from "react";
import useStoreState from "@/components/providers/useStoreState";

import SelectionStore from "@/stores/SelectionStore";

/**
 * @typedef {Record<string, boolean>} GroupPanelState
 */

/**
 * Tracks group panel open state. Listens to selection store to open from stage selection.
 * @returns {[ GroupPanelState, import("react").Dispatch<import("react").SetStateAction<GroupPanelState>> ]}
 */
export const useGroupPanelOpen = (parentId) => {
  const [isGroupOpen, setIsGroupOpen] = useState({});
  const selectedElements = useStoreState(SelectionStore, SelectionStore.getElements);

  useEffect(() => {
    for (const element of [...selectedElements.values()]) {
      const { containedBy, containerId } = element;
      const containedByParent = containerId && containedBy && containedBy.startsWith(parentId);

      if (!containedByParent) continue;

      if (!isGroupOpen[containerId]) {
        setIsGroupOpen((prev) => ({ ...prev, [containerId]: true }));
        break;
      }
    }
  }, [selectedElements]);

  useEffect(() => {
    setIsGroupOpen({});
  }, [parentId]);

  return useMemo(() => [isGroupOpen, setIsGroupOpen], [isGroupOpen, setIsGroupOpen]);
};
